/**
 * @generated SignedSource<<aea5f4b3b9e464fd86a57c31e4cff32d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type AgenticWorkerResultState = "NEEDS_REVIEW" | "DONE" | "DELETED" | "%future added value";
export type AgenticWorkerRowType = "PROJECT_BILLING_ROW" | "RETAINER_PERIOD_ROW" | "%future added value";
export type AgenticWorkerRunState = "RUNNING" | "STOPPED" | "NOTHING_FOUND" | "PRODUCED" | "FAILED" | "NOT_STARTED" | "%future added value";
export type AgenticWorkerScopeKind = "PAGE" | "ROW" | "%future added value";
export type agentRunStateQuery$variables = {
  agentId: string;
};
export type agentRunStateQuery$data = {
  readonly viewer: {
    readonly agenticWorker: {
      readonly activeRuns: ReadonlyArray<{
        readonly id: string;
        readonly scopeKind: AgenticWorkerScopeKind;
        readonly scopeRowType: AgenticWorkerRowType | null;
        readonly scopeRowId: number | null;
        readonly state: AgenticWorkerRunState;
        readonly rows: ReadonlyArray<{
          readonly rowType: AgenticWorkerRowType;
          readonly rowId: number;
        }>;
      }>;
      readonly waitingResults: ReadonlyArray<{
        readonly id: string;
        readonly runId: string;
        readonly rows: ReadonlyArray<{
          readonly rowType: AgenticWorkerRowType;
          readonly rowId: number;
        }>;
        readonly state: AgenticWorkerResultState;
        readonly hidden: boolean;
      }>;
    } | null;
  } | null;
};
export type agentRunStateQuery = {
  variables: agentRunStateQuery$variables;
  response: agentRunStateQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "agentId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "AgenticWorkerResultRow",
  "kind": "LinkedField",
  "name": "rows",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rowType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rowId",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "agentId",
      "variableName": "agentId"
    }
  ],
  "concreteType": "AgenticWorker",
  "kind": "LinkedField",
  "name": "agenticWorker",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AgenticWorkerRun",
      "kind": "LinkedField",
      "name": "activeRuns",
      "plural": true,
      "selections": [
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "scopeKind",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "scopeRowType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "scopeRowId",
          "storageKey": null
        },
        (v2/*: any*/),
        (v3/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AgenticWorkerResult",
      "kind": "LinkedField",
      "name": "waitingResults",
      "plural": true,
      "selections": [
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "runId",
          "storageKey": null
        },
        (v3/*: any*/),
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hidden",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "agentRunStateQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "agentRunStateQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "753caa6815c81fdfd45a59d9b22b4145",
    "id": null,
    "metadata": {},
    "name": "agentRunStateQuery",
    "operationKind": "query",
    "text": "query agentRunStateQuery(\n  $agentId: String!\n) {\n  viewer {\n    agenticWorker(agentId: $agentId) {\n      activeRuns {\n        id\n        scopeKind\n        scopeRowType\n        scopeRowId\n        state\n        rows {\n          rowType\n          rowId\n        }\n      }\n      waitingResults {\n        id\n        runId\n        rows {\n          rowType\n          rowId\n        }\n        state\n        hidden\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "4afa79abac7c0f9d5daaa1e5af7acfe7";

export default node;
